import React, { useState, useEffect, useRef } from "react";
import { Eye } from "lucide-react";
import { primaryColor } from "../constants/colors";
import {
  useGetVisitorCountQuery,
  useVisitorCountMutation,
} from "../redux/api/user/AuthApi";

export default function VisitorCounter() {
  const [showTooltip, setShowTooltip] = useState(false);
  const visitedRef = useRef(false);
  const [isTop, setIsTop] = useState(true);
  const [recordVisit] = useVisitorCountMutation();
  const { data } = useGetVisitorCountQuery();
  const visitorCount = data?.count || 0;

  useEffect(() => {
    if (!visitedRef.current) {
      recordVisit();
      visitedRef.current = true;
    }
  }, [recordVisit]);

  const counterStyle = {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "13px",
  };

  const iconStyle = {
    width: "14px",
    height: "14px",
    opacity: 0.8,
  };

  return (
    <div className="visitor-counter-static" style={counterStyle}>
      <Eye style={iconStyle} />
      <span>
        Visitors: <b>{visitorCount.toLocaleString()}</b>
      </span>
    </div>
  );
}
